import React, { useContext } from 'react';
import clsx from 'clsx';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { withStyles } from '@material-ui/core/styles';

import MetaContext from './MetaContext';

// Style overrides for the internals of Table.NoDataCell
const styles = {
    errorCell: {
        color:         'red',
        verticalAlign: 'top'
    },
    errorText: {
        transform:   'none',
        msTransform: 'none',
        display:     'block',
        width:       '50%'
    },
    errorTextContainer: {
        justifyContent: 'center',
        display:        'flex',
        lineHeight:     1.5
    },
    textContainer: {
        fontSize: '1.2rem'
    }
};

const NoDataCell = ({
    classes: {
        errorCell,
        errorText,
        errorTextContainer,
        ...styles
    },
    ...props
}) => {
    const meta = useContext(MetaContext);
    const hasError = Boolean(meta.error);
    // Conditionally merge error style overrides into classes if an error
    // is present
    const classes = {
        ...styles,
        cell: clsx(
            styles.cell,
            {
                [errorCell]: hasError
            }
        ),
        text: clsx(
            styles.text,
            {
                [errorText]: hasError
            }
        ),
        textContainer: clsx(
            styles.textContainer,
            {
                [errorTextContainer]: hasError
            }
        )
    };
    return <Table.NoDataCell classes={classes} {...props}  />;
};

export default withStyles(styles)(NoDataCell);
